import { Box } from "@mui/material";

import { TextareaAutosize } from "@mui/material";
import { useTheme } from "@emotion/react";

import CountyForm from "./Form";
import { CountiesColumns } from "../../../../data/Columns/GeographicalColumns";
import { allCounties } from "../../../../data/Queries/SetupManagement/GeographicalSetupsQueries";
import { setupManagementUrl } from "../../../../config";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";

const base_url = setupManagementUrl.uri;
const actions = {
  entity: "County",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
  },
  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
};
function Counties() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Country"
          subtitle="Manage Countries"
          columns={CountiesColumns}
          FormComponent={CountyForm}
          query={allCounties}
          base_url={base_url}
          actions={actions}
        />
      </>
    </Box>
  );
}

export default Counties;
